import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.css";
import { useEffect, useState } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { ToastProvider, useToast } from './context/ToastContext';
import { loginRequest } from './authConfig';
import { fetchUserData } from './store/slices/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Routing from './Routing';
import NoAccess from './components/NoAccess/noAccess';
import Spinner from "./components/Spinner/spinner";

const AppContent = () => {
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const { showError } = useToast();
  const [token, setToken] = useState(false);
  const [isAcquiringToken, setIsAcquiringToken] = useState(false);
  const { userData, loading, noAccess } = useSelector(state => state?.user);
  const userType = localStorage.getItem('userType');
  const userTypeRole = userData?.userTypes?.find(type =>
  type?.userType?.toLowerCase()?.includes(userType?.toLowerCase())
);
  const isSuperAdmin = userTypeRole?.userTypeRoleId === 1;
  const isHr  = [2].includes(userTypeRole?.userTypeRoleId);
  const isAccounts = [ 3].includes(userTypeRole?.userTypeRoleId);

  useEffect(() => {
    if (isAuthenticated && !token) {
      const getIdToken = () => {
        setIsAcquiringToken(true);
        const request = {
          ...loginRequest,
          account: accounts[0],
        };
        instance
          .acquireTokenSilent(request)
          .then((response) => {
            if (response.idToken) {
              setToken(true);
              localStorage.setItem("idToken", response.idToken);
              // Fetch user data after successful token retrieval
              dispatch(fetchUserData());
            } else {
              showError('Authentication Error', 'No ID token received');
              localStorage.clear();
              setToken(false);
            }
          })
          .catch((error) => {
            console.error("Error acquiring token:", error);
            showError('Authentication Error', error.message);
            localStorage.clear();
            setToken(false);
            // Try interactive sign in
            instance.acquireTokenPopup(request)
              .then((response) => {
                if (response.idToken) {
                  setToken(true);
                  localStorage.setItem("idToken", response.idToken);
                  // Fetch user data after interactive sign in
                  dispatch(fetchUserData());
                }
              })
              .catch((error) => {
                console.error("Error in interactive sign in:", error);
                showError('Authentication Error', 'Failed to acquire authentication token. Please try again.');
                localStorage.clear();
                setToken(false);
              });
          })
          .finally(() => {
            setIsAcquiringToken(false);
          });
      };

      getIdToken();
    }
  }, [isAuthenticated, token, instance, accounts, dispatch, showError]);

  // Handle navigation based on user data
  useEffect(() => {
    if (!noAccess) {
      if (userData && location.pathname === '/') {
        if (userData.userTypes?.length > 1) {
          navigate('/select-user-type');
        } else if (userData?.userTypes?.length === 1) {          
          navigate(isSuperAdmin ? '/admin/timesheet-list': isAccounts ? '/user/employees/timesheets' :isHr? '/hr/employees/timesheets': '/user/timesheet');
        }
      }
      if (userData) {
        if (Array.isArray(userData?.userTypes) && userData?.userTypes?.length === 0) {
          navigate('/no-access');
        }
      }
    }
  }, [userData, navigate, location.pathname, noAccess, isSuperAdmin, isHr,isAccounts, userTypeRole]);

  if (noAccess) {
    return <NoAccess />;
  }

  if (isAcquiringToken || loading) {
    return <Spinner fullPage />;
  }

  return <Routing isAuthenticated={isAuthenticated} token={token} />;
};

function App() {
  return (
    <Provider store={store}>
      <ToastProvider>
        <AppContent />
      </ToastProvider>
    </Provider>
  );
}

export default App;
